/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TooManySetupCombinationsExceptionDetails
 */
export interface TooManySetupCombinationsExceptionDetails {
    /**
     * 
     * @type {number}
     * @memberof TooManySetupCombinationsExceptionDetails
     */
    readonly maxCombinationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TooManySetupCombinationsExceptionDetails
     */
    readonly totalCombinationCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TooManySetupCombinationsExceptionDetails
     */
    $type?: TooManySetupCombinationsExceptionDetailsTypeEnum;
}


/**
 * @export
 */
export const TooManySetupCombinationsExceptionDetailsTypeEnum = {
    PtwPtw100AppZeroApplicationTaskItemComponentTooManySetupCombinationsExceptionDetailsPtwPtw100AppZeroApplication: 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.TooManySetupCombinationsExceptionDetails, Ptw.Ptw100.AppZero.Application'
} as const;
export type TooManySetupCombinationsExceptionDetailsTypeEnum = typeof TooManySetupCombinationsExceptionDetailsTypeEnum[keyof typeof TooManySetupCombinationsExceptionDetailsTypeEnum];


/**
 * Check if a given object implements the TooManySetupCombinationsExceptionDetails interface.
 */
export function instanceOfTooManySetupCombinationsExceptionDetails(value?: unknown): value is TooManySetupCombinationsExceptionDetails {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TooManySetupCombinationsExceptionDetailsTypeEnum)[0];
}

export function TooManySetupCombinationsExceptionDetailsFromJSON(json: any): TooManySetupCombinationsExceptionDetails {
    return TooManySetupCombinationsExceptionDetailsFromJSONTyped(json, false);
}

export function TooManySetupCombinationsExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TooManySetupCombinationsExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maxCombinationCount': !exists(json, 'maxCombinationCount') ? undefined : json['maxCombinationCount'],
        'totalCombinationCount': !exists(json, 'totalCombinationCount') ? undefined : json['totalCombinationCount'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TooManySetupCombinationsExceptionDetailsToJSON(value?: TooManySetupCombinationsExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value.$type,
    });
}

